import React from 'react';
import { createRoot } from 'react-dom/client';
import { GasQueryProvider, GasToastProvider, GasConfirmProvider } from '../../shared/kit';
import App from './App';
import type { PublicMembersListInitData } from './types';
import './style.css';

const mountEl = document.getElementById('gas-public-members-list-app');

if (mountEl?.dataset.reactInit && mountEl.isConnected) {
    let initData: PublicMembersListInitData | null = null;

    try {
        initData = JSON.parse(mountEl.dataset.reactInit) as PublicMembersListInitData;
    } catch (error) {
        mountEl.innerHTML = '';
        throw error;
    }

    if (initData) {
        createRoot(mountEl).render(
            <React.StrictMode>
                <GasQueryProvider>
                    <GasToastProvider>
                        <GasConfirmProvider>
                            <App initData={initData} />
                        </GasConfirmProvider>
                    </GasToastProvider>
                </GasQueryProvider>
            </React.StrictMode>,
        );
    }
}
